import { StudentIntakeElementKind } from "../studentIntake/studentIntakeTypes";
import { isEmpty } from 'lodash';
import { urlParams } from "./request";
import { isValidOrBlankEmail } from './text';

export const isQuestionWithValidValue = element => {
  if (element.kind !== StudentIntakeElementKind.question) return false;
  // If the type is string, check to make sure it's not empty
  if (typeof element.value === 'string' && !isEmpty(element.value)) return true;
  // If the type is set to number, it must be valid
  if (typeof element.value === 'number') return true;
  // If the type is set to boolean, it must be valid
  if (typeof element.value === 'boolean') return true;
  // If the type is object, we need to check if option is null
  if (typeof element.value === "object" && !isEmpty(element.value) && element.value.option === null) return false;
  // If it doesn't fit any of these, fallback to null check
  return !isEmpty(element.value);
};

export const isValidAnswer = element => {
  if (element.type === 'EMAIL') return isValidOrBlankEmail(element.value);
  if (element.type === 'FULL_DATE' || element.type === 'MONTH_YEAR') return element.value !== 'Invalid Date';
  
  // Rest of the types will be valid by default
  return true;
};

export const missingRequiredAnswers = (elements) =>
  elements.filter(
    element => element.required && !isQuestionWithValidValue(element)
  ).length > 0;

export const invalidAnswersByType = (elements) => 
  elements.filter(
    element => isQuestionWithValidValue(element) && !isValidAnswer(element)
  ).length > 0;

export const getPrintIntakeURL = (studentId) => {
  if (!studentId) return '#';
  return `../instructor/printStudentIntakeForm.html?${urlParams({studentId})}`;
};

// Make sure we scroll to the top of the page if some error shows up. Otherwise the
// banner will display but the user won't be able to see it
export const scrollToTop = () => {
  const formElement = document.querySelector("#sf-react-intake-form");
  if ( formElement ) formElement.scrollTo(0, 0);
};

export const submitIntakeForm = async (callAPI, studentId, surveyId, intakeFormElements, multipleStudentSurveysEnabled) => {
  // Eventually we should remove the !!surveyId condition, this is just to make things work more smoothly during
  // these initial building stages
  const URL = multipleStudentSurveysEnabled && !!surveyId ? `../student-surveys/saveStudentSurvey.html` : `../student/saveIntakeForm.html`;
  await callAPI(URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      studentId: studentId,
      surveyId: surveyId,
      elements: intakeFormElements
        .filter(element => element.kind === StudentIntakeElementKind.question)
        .map(element => isQuestionWithValidValue(element) 
            ? ({questionId: element.questionId, value: element.value, questionType: element.type})
            : ({questionId: element.questionId, questionType: element.type})
        )
    })
  });
  scrollToTop();
};

export const padTwoChars = (number) => (number < 10 ? '0' : '') + number
